import { render, staticRenderFns } from "./WfhEligibilityCard.vue?vue&type=template&id=4ea56982"
import script from "./WfhEligibilityCard.vue?vue&type=script&lang=js"
export * from "./WfhEligibilityCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports